<template>
    <a-card title="公共元素库">
      <a-input-search style="margin-bottom: 8px;" placeholder="搜索" @change="onChange" />
      <a-tree
        @select="onSelect"
        class="tree"
        :expanded-keys="expandedKeys"
        :auto-expand-parent="autoExpandParent"
        :tree-data="treeData"
        :load-data="onLoadData"
        :replaceFields="replaceFields"
        @expand="onExpand"
      >
        <template slot="title" slot-scope="{ id,name,category }">
          <a-icon :type="category==='1'?'folder':'file'" :theme="category==='1'?'filled':null"></a-icon>
          <!--<a-button icon="plus" type="link" size="small">-->

          <!--</a-button>-->
          <a-dropdown :trigger="['contextmenu']">
            <span v-if="name.indexOf(searchValue) > -1">
              {{ name.substr(0, name.indexOf(searchValue)) }}
              <span style="color: #f50">{{ searchValue }}</span>
              {{ name.substr(name.indexOf(searchValue) + searchValue.length) }}
            </span>
            <span v-else>{{ name }}</span>
            <template #overlay>
              <a-menu @click="({ key: menuKey }) => onContextMenuClick(id, menuKey)">
                <a-menu-item key="add2" v-has="'element:public:add2'">添加元素</a-menu-item>
                <a-menu-item key="add1" v-has="'element:public:add1'">添加分类</a-menu-item>
                <a-menu-item key="delete" v-has="'element:public:delete'">删除</a-menu-item>
              </a-menu>
            </template>
          </a-dropdown>
        </template>
      </a-tree>
    </a-card>
</template>

<script>
  import { getAction,postAction } from '@/api/manage'
  export default {
    name: 'PublicElement',
    data(){
      return {
        dataList:[],
        expandedKeys: ['-1'],
        searchValue: '',
        autoExpandParent: true,
        treeData:[
          {
            id: `-1`,
            name: `元素库`,
            category: '1',
            children: []
          }
        ],
        replaceFields:{children:'children', title:'name', key:'id' }
      }
    },
    mounted(){
      // this.loadData()
    },
    methods:{
      onLoadData(treeNode){
        // console.log(treeNode.dataRef)
        const that = this
        return new Promise((resolve)=>{
          that.loadData(treeNode.dataRef,resolve)
        })
      },
      loadData(parentNodeData,callBack){
        const parentId = parentNodeData.id==='-1'?null:parentNodeData.id
        getAction('/project/projectElement/publicList',{parentId:parentId}).then(res=>{
          if(res.success){
            parentNodeData.children = res.result
            this.$nextTick(()=>{
              this.generateList(parentNodeData.children)
              // if(! this.expandedKeys.length>0){
              //   this.dataList.forEach(item=>{
              //     if(item.category==='1'){
              //       this.expandedKeys.push(item.id)
              //     }
              //   })
              // }
              if(callBack){
                callBack()
              }
            })
          }
        })
      },
      onChange(e){
        const value = e.target.value;
        const expandedKeys = this.dataList
          .map(item => {
            if (item[this.replaceFields.title].indexOf(value) > -1) {
              return this.getParentKey(item[this.replaceFields.key], this.treeData);
            }
            return null;
          })
          .filter((item, i, self) => item && self.indexOf(item) === i);
        Object.assign(this, {
          expandedKeys,
          searchValue: value,
          autoExpandParent: true,
        });
      },
      onExpand(expandedKeys) {
        this.expandedKeys = expandedKeys;
        this.autoExpandParent = false;
        console.log('123')
      },
      getParentKey(key, tree) {
        let parentKey;
        for (let i = 0; i < tree.length; i++) {
          const node = tree[i];
          if (node[this.replaceFields.children]) {
            if (node[this.replaceFields.children].some(item => item[this.replaceFields.key] === key)) {
              parentKey = node[this.replaceFields.key];
            } else if (this.getParentKey(key, node[this.replaceFields.children])) {
              parentKey = this.getParentKey(key, node[this.replaceFields.children]);
            }
          }
        }
        return parentKey;
      },
      generateList(data){
        for (let i = 0; i < data.length; i++) {
          const node = data[i];
          this.dataList.push(Object.assign({},node))
          if (node[this.replaceFields.children]) {
            this.generateList(node[this.replaceFields.children]);
          }
        }
      },
      onContextMenuClick(id,key){
        switch (key) {
          case 'add1':
            this.handleAdd1(id)
            break
          case 'add2':
            this.handleAdd2(id)
            break
          case 'delete':
            this.handleDelete(id)
            break;
        }
      },
      handleAdd1(id){
        this.$emit('handleAdd',id,'1')
      },
      handleAdd2(id){
        this.$emit('handleAdd',id,'2')
      },
      handleDelete(id){
        this.$emit('handleDelete',id)
      },
      onSelect(selectedKeys,e){
        const datas = this.dataList.filter(item=> item.id===selectedKeys[0])
        this.$emit('onSelect',datas[0])
      },
    }
  }
</script>

<style scoped lang="less">
  .tree{
    height: calc(100vh - 300px);
    overflow-y: auto;
  }
</style>